function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable deprecation/deprecation */
import { hydro2 } from './hydro2';
var surface = hydro2.surface,
  primary = hydro2.primary,
  secondary = hydro2.secondary,
  tertiary = hydro2.tertiary,
  text = hydro2.text,
  status = hydro2.status;

/** @deprecated */

/** @deprecated */

/** @deprecated */
export var legacyColorPalette = {
  surface: {
    backgroundGrey: surface.secondary,
    // backgroundGrey.primary
    white: surface.primary,
    // white.primary
    whiteHover: surface.secondary // backgroundGrey.hover
  },
  "static": {
    textGrey: text.dark.primary,
    // textGrey.primary
    textMedium: text.dark.secondary,
    // textGrey.medium
    textLight: text.dark.disabled,
    // textGrey.light
    groupBlue: primary.main,
    // groupBlue.primary
    groupMedium: primary.light,
    // groupBlue.medium
    groupLight: primary.light // groupBlue.light
  },
  interaction: {
    linkBlue: secondary.main,
    // linkBlue.primary
    linkHover: secondary.dark,
    // actionBlue.hover
    actionBlue: secondary.main,
    // actionBlue.primary
    actionHover: secondary.dark,
    // actionBlue.hover
    actionMedium: secondary.light,
    // actionBlue.medium
    actionLight: secondary.light,
    primaryOrange: tertiary.main,
    // primaryOrange.primary
    primaryHover: tertiary.dark,
    // primaryOrange.hover
    uiEnabled: text.dark.secondary,
    uiDisabled: text.dark.disabled
  },
  status: {
    yesGreen: status.success,
    // new green
    cautionAmber: status.warning,
    // new yellow
    noRed: status.alert // noRed.primary
  }
};

/** @deprecated */
export var legacyColors = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, legacyColorPalette.surface), legacyColorPalette["static"]), legacyColorPalette.interaction), legacyColorPalette.status);